<template>
    <div class="modal-card" style="width: auto">
        <div class="modal-card-head">
            <header v-if="rulesFulfilled">
                {{ $t('discount.voucherIsValid') }}
            </header>
            <header v-else>
                {{ $t('discount.belowMinimumOrderTotal') }}
            </header>
        </div>
        <div class="modal-card-body">
            <div class="voucher-discount">
                <template v-if="discount.type === 'percentage'">
                    <p
                        class="titlte is-2"
                        v-html="
                            $t('discount.relativeDiscount', {
                                value: discount.value,
                            })
                        "
                    ></p>
                </template>
                <template v-else-if="discount.type === 'absolute'">
                    <div class="title is-2">
                        <p
                            v-if="isBusinessCustomer"
                            v-html="
                                $t(
                                    'discount.absoluteDiscountBusinessCustomers',
                                    {
                                        value: discount.value,
                                    }
                                )
                            "
                        ></p>
                        <p
                            v-else
                            v-html="
                                $t('discount.absoluteDiscount', {
                                    value: discount.calculatedTaxes.totalPrice,
                                })
                            "
                        ></p>
                    </div>
                </template>
                <template v-if="discount.rules.freeShipping">
                    <p
                        class="is-size-5 py-2"
                        v-html="$tc('discount.freeShipping')"
                    ></p>
                </template>
            </div>
            <div class="voucher-conditions pt-4" v-if="!rulesFulfilled">
                <div
                    class="divider has-background-grey mb-5"
                    style="width: 100%"
                ></div>
                <template
                    v-if="discount.rules.minValue && isBelowMinimumOrderTotal"
                >
                    <p
                        class="is-size-5 py-2"
                        v-html="
                            $t('discount.minimumOrderTotal', {
                                amount: discount.rules.minValue.toFixed(2),
                            })
                        "
                    ></p>
                    <p
                        class="is-size-5 py-2"
                        v-html="
                            $t('discount.orderGoal', {
                                amount: orderGoal.toFixed(2),
                            })
                        "
                    ></p>
                </template>
                <template v-else-if="discount.rules.maxUsage">
                    <p
                        class="is-size-5 py-2"
                        v-html="
                            $tc(
                                'discount.applicableXTimes',
                                discount.rules.maxUsage
                            )
                        "
                    ></p>
                </template>
            </div>
        </div>
        <div class="modal-card-foot is-flex is-justify-content-flex-end">
            <b-button @click="discardDiscount">
                {{ $t('discount.actionLabels.continueShopping') }}
            </b-button>
            <b-button
                v-if="rulesFulfilled"
                @click="applyDiscount"
                type="is-primary-dark"
            >
                {{ $t('discount.actionLabels.redeemDiscount') }}
            </b-button>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'VoucherModal',
    computed: {
        ...mapGetters([
            'discount',
            'positionPrice',
            'taxRate',
            'isBusinessCustomer',
        ]),
        isBelowMinimumOrderTotal() {
            if (this.discount.rules && this.discount.rules.minValue) {
                return (
                    this.positionPrice.totalPrice < this.discount.rules.minValue
                );
            }
            return false;
        },
        orderGoal() {
            if (this.discount.rules && this.discount.rules.minValue) {
                return (
                    this.discount.rules.minValue - this.positionPrice.totalPrice
                );
            }
            return 0;
        },
        rulesFulfilled() {
            return !this.isBelowMinimumOrderTotal;
        },
    },
    methods: {
        discardDiscount() {
            this.$store.dispatch('discardDiscount');
            this.$parent.close();
        },
        applyDiscount() {
            this.$store.dispatch('applyDiscount');
            this.$parent.close();
        },
    },
};
</script>

<style scoped></style>
